
import React, { useState } from 'react';
import { COLORS } from '../constants';

const services = [
  { id: '01', title: 'Solar panels for home' },
  { id: '02', title: 'Solar panels for industry' },
  { id: '03', title: 'Solar panels for chargers' },
  { id: '04', title: 'Wind power generator' }
];

const ServiceDiscovery: React.FC = () => {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <section className="py-12 md:py-20 bg-white" id="services">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid lg:grid-cols-[1.1fr_0.9fr] gap-10 lg:gap-24 items-start">
          
          <div className="flex flex-col">
            <div className="mb-8 md:mb-12 space-y-6 md:space-y-8">
              <h2 className="fluid-heading-lg font-bold leading-[1.1] tracking-tight text-[#1E1E1E] reveal-item">
                Trusted service, <br />
                <span className="text-gray-400 font-medium">for your various needs</span>
              </h2>
              <button 
                className="group text-white text-[13px] font-bold px-7 py-3.5 rounded-full flex items-center gap-2 transition-all hover:scale-105 active:scale-95 shadow-lg shadow-emerald-500/20 w-fit reveal-item"
                style={{ backgroundColor: COLORS.novusGreen, transitionDelay: '0.1s' }}
              >
                Get in touch
                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                  <path d="M7 17l10-10M7 7h10v10" />
                </svg>
              </button>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
              {services.map((s, idx) => (
                <div 
                  key={s.id} 
                  className="p-8 md:p-10 border border-gray-100 rounded-[0.4rem] md:rounded-[0.8rem] bg-white transition-all duration-300 hover:shadow-xl hover:shadow-gray-100 hover:border-gray-200 reveal-item"
                  style={{ transitionDelay: `${0.1 + (idx * 0.05)}s` }}
                >
                  <p className="text-xs md:text-sm font-medium text-gray-400 mb-4 md:mb-6">{s.id}</p>
                  <h3 className="text-xl md:text-2xl font-bold mb-6 md:mb-8 leading-snug text-[#1E1E1E] max-w-[200px]">
                    {s.title}
                  </h3>
                  <a 
                    href="#" 
                    className="inline-block text-xs md:text-sm font-bold text-[#1E1E1E] border-b-2 border-[#1E1E1E] pb-0.5 hover:text-emerald-500 hover:border-emerald-500 transition-colors"
                  >
                    View Details
                  </a>
                </div>
              ))}
            </div>
          </div>

          <div className="w-full reveal-item" style={{ transitionDelay: '0.3s' }}>
            <div className="relative aspect-[3/4] md:aspect-[3/3.8] lg:aspect-[3/4.1] rounded-[0.4rem] md:rounded-[0.8rem] overflow-hidden shadow-2xl bg-gray-100 img-shimmer">
              <img 
                src="https://i.imgur.com/0mw0zbZ.jpeg?q=60&w=1200" 
                className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ${imageLoaded ? 'opacity-100' : 'opacity-0'}`} 
                alt="Solar technician holding a solar panel" 
                loading="lazy"
                onLoad={() => setImageLoaded(true)}
              />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ServiceDiscovery;
